import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { useServiceProvider } from '@pflegenavi/service-provider-frontend/api';
import {
  shouldUseNewLogin,
  useAuthentication as useNewAuthentication,
} from '@pflegenavi/shared-frontend/authentication';
import { PaymentProcessor } from '@pflegenavi/shared/api';
import { LoadingContainer } from '@pflegenavi/web-components';
import { useMemo, type JSX } from 'react';
import { Route } from 'react-router-dom';
import { ConnectAccountPage } from '../pages/ConnectAccountPage';
import { ConnectMangopayAccountPage } from '../pages/ConnectMangopayAccountPage';
import { NewInvitationPage } from '../pages/NewInvitationPage';
import { SentryRoutes } from '../sentry';
import { getGlobalServiceProviderIdFromToken } from '../utils/getGlobalServiceProviderIdFromToken';

export const ConnectApp = (): JSX.Element => {
  const auth = useNewAuthentication(shouldUseNewLogin());

  const globalServiceProviderId = getGlobalServiceProviderIdFromToken(
    auth?.token
  );

  const { data: serviceProvider } = useServiceProvider(
    {
      globalServiceProviderId,
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const isMangopayActive = useMemo(() => {
    return serviceProvider?.paymentProcessor === PaymentProcessor.Mangopay;
  }, [serviceProvider?.paymentProcessor]);

  return (
    <SentryRoutes>
      <Route
        path={spAppMainPages.CONNECT_ACCOUNT}
        element={
          isMangopayActive ? (
            <ConnectMangopayAccountPage />
          ) : (
            <ConnectAccountPage />
          )
        }
      />
      <Route
        path={spAppMainPages.NEW_INVITATION}
        element={<NewInvitationPage />}
      />
      <Route path="*" element={<LoadingContainer />} />
    </SentryRoutes>
  );
};
